import { render, staticRenderFns } from "./inventoryFlow.vue?vue&type=template&id=cf8e2b5a&scoped=true&"
import script from "./inventoryFlow.vue?vue&type=script&lang=js&"
export * from "./inventoryFlow.vue?vue&type=script&lang=js&"
import style0 from "./inventoryFlow.vue?vue&type=style&index=0&id=cf8e2b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8e2b5a",
  null
  
)

export default component.exports